<script setup lang="ts">
import { WidgetHeader } from "~/widgets/header";
import { WidgetFooter } from "~/widgets/footer";
import { WidgetScrollUp } from "~/widgets/scroll-up";
import { WidgetCookieBanner } from "~/widgets/cookie-banner";
import type { NuxtError } from "#app";

const searchClient = useSearchClient();

const content = usePublicContent();
await useAsyncData("config", () => content.getConfig());
await useAsyncData("region", () => $fetch("/api/regions"), {
    transform: (r) => r.regions?.[0],
});

await useAsyncData("categories", () =>
    $fetch("/api/categories").then((r) => r.product_categories),
);

const props = defineProps<{
    error: NuxtError;
}>();

const errorName = computed(() => {
    return props.error.statusCode === 404
        ? "Возможно вы ошиблись, Такой страницы не существует"
        : props.error.message;
});

const siteConfig = useSiteConfig();

useSeoMeta({
    title: () => siteConfig.name,
    description: () => siteConfig.description,
});
</script>
<template>
    <div class="flex flex-col min-h-screen w-full pb-12 lg:pb-0">
        <WidgetHeader position="static" />
        <div
            class="flex py-8 lg:py-20 bg-[url(/error-page.jpg)] bg-cover bg-center flex-col text-white flex-1 justify-center items-center"
        >
            <div class="text-[8.25rem] text-center mb-9 font-semibold italic">
                {{ error.statusCode }}
            </div>
            <div class="font-medium mb-12 text-center text-2xl">
                {{ errorName }}
            </div>
            <UiButton variant="secondary" is-link to="/"
                >Перейти на главную</UiButton
            >
        </div>
        <WidgetFooter />
        <WidgetScrollUp />
        <WidgetCookieBanner />
    </div>
</template>
